

























































import { Component, Prop, Vue } from 'vue-property-decorator'
import { UserDto } from '@/models/dtos/userDto'
import { mixins } from 'vue-class-component'
import { UserMixin } from '@/mixins/userMixin'

@Component
export default class SelectUserModal extends mixins(UserMixin) {
  @Prop({ type: Array, required: true }) users!: UserDto[];

  // Data
  private selectedUsers: UserDto[] = []

  // Methods
  private saveUsers() {
    this.$emit('selected', this.selectedUsers.map(u => u.id))
  }

  selectUser(user: UserDto) {
    this.selectedUsers.push(user)
  }

  removeUser(id: string) {
    this.selectedUsers = this.selectedUsers.filter(u => u.id !== id)
  }

  showModal() {
    this.selectedUsers = [] as UserDto[]
    this.$bvModal.show('select-user-modal')
  }

  // Getters
  private get notAssigned() {
    return this.users.filter(u => !this.selectedUsers.some(assigned => assigned.id === u.id))
  }

  // Lifecycle
  mounted() {
    this.$root.$on('show-select-user-modal', () => {
      this.showModal()
    })
  }
}
